// *** Mutation single change state for vuex change state ***
const mutationSingleChangeState = (state, payload) => {
    return payload.payloads.forEach((val) => {
        state[val.key] = val.value;
    });
};

export default mutationSingleChangeState;

